'use client'

import { ProductReviewsFilterDesktop } from '@/app/product/[slug]/_components/product-reviews/filter/filter-desktop'
import { ReviewsHeaderList } from '@/app/product/[slug]/_components/product-reviews/product-reviews-desktop/reviews-header-list'
import { ProductReviewsItem } from '@/app/product/[slug]/_components/product-reviews/product-reviews-item'
import { ProductReviewsRating } from '@/app/product/[slug]/_components/product-reviews/rating'
import { Pagination } from '@/components/ui/pagination'
import { useReview } from '@/hooks/react-query/reviews/use-review'
import { PaginatedReviewResponse } from '@/types/api'
import { ReviewItem } from '@/types/collection'
import { useState } from 'react'

type Props = {
  productId: string
  reviewAvg: number
  reviewCount: number
}

export const ProductReviewsDesktop = ({
  productId,
  reviewAvg,
  reviewCount,
}: Props) => {
  const [page, setPage] = useState(1)
  const [filter, setFilter] = useState<string>('')
  const [keywords, setKeywords] = useState<string>('')

  const { data } = useReview(productId, {
    page,
    limit: 10,
    filter,
    keywords,
  })

  // Cast to correct type
  const reviewData = data as PaginatedReviewResponse<ReviewItem[]> | undefined
  const reviews = reviewData?.data || []
  const totalPages = reviewData?.last_page || 1
  const totalItems = reviewData?.total || 0

  const handleFilterChange = (value: string) => {
    setFilter(value)
    setPage(1) // Reset to first page when filter changes
  }

  const handleSearchChange = (value: string) => {
    setKeywords(value)
    setPage(1) // Reset to first page when search changes
  }

  return (
    <section className='flex gap-24 bg-neutral-100 px-4 py-10 pt-20 max-lg:hidden lg:px-15 lg:py-14'>
      <div className='basis-1/5'>
        <h2 className='mb-12 font-criteria text-4xl font-medium uppercase leading-[47px] text-neutral-900'>
          Đánh giá <br /> sản phẩm
        </h2>
        <ProductReviewsFilterDesktop
          onFilterChange={handleFilterChange}
          onSearchChange={handleSearchChange}
        />
      </div>
      <div className='flex-1'>
        <div className='mb-8 flex items-center justify-between pr-[102px]'>
          <ProductReviewsRating
            reviewAvg={reviewAvg}
            reviewCount={reviewCount}
          />
          {/* <ProductReviewsSizeFitDistribution /> */}
        </div>
        <ReviewsHeaderList
          onFilterChange={handleFilterChange}
          currentPage={page}
          totalItems={totalItems}
          itemsPerPage={10}
        />
        <div
          className='mt-5 space-y-3'
          role='list'
          aria-label='Product reviews list'
        >
          {reviews.map((review: ReviewItem) => (
            <ProductReviewsItem key={review._id} review={review} />
          ))}
        </div>
        <Pagination
          totalPages={totalPages}
          page={page}
          onPageChange={setPage}
          wrapperClassName='mt-6 justify-end'
          className='gap-3'
        />
      </div>
    </section>
  )
}
